import moment from 'moment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Constants } from '@config/constants';
import { HttpClient } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import {
  IMachineTotals,
  IMachineTotalJobs,
  IMachineJobsFilter,
  IMachineDailyWorks,
} from 'app/models';
import { ErrorHandlingService } from '../error-handling/error.handling.service';

@Injectable()
export class DataWorkService {
  constructor(
    private readonly http: HttpClient,
    private readonly constants: Constants,
    private readonly errorHandlingService: ErrorHandlingService
  ) {}

  downloadDataWorkCSV = (queryParams: string): any =>
    this.http
      .get(
        `${this.constants.DATAWORKS_CSV_ENDPOINT}?${queryParams}`,
        {responseType: 'blob'}
      );

  getDailyJobsByMachine = (
    machineId: number
  ): Observable<IMachineDailyWorks[]> =>
    this.http
      .get<IMachineDailyWorks[]>(
        `${this.constants.DATAWORK_BY_MACHINE_ENDPOINT}/${machineId}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );

  getTotalJobsByMachine = ({
    machineId,
    dateRange: { startDate, endDate } = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    },
  }: IMachineJobsFilter): Observable<IMachineTotalJobs[]> =>
    this.http
      .get<IMachineTotalJobs[]>(
        `${
          this.constants.DATAWORKS_ENDPOINT
        }?machineId=${machineId}&from=${moment(startDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&to=${moment(endDate).format('YYYY-MM-DDTHH:mm:ss')}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );


  getTotals = ({
    machineId,
    dateRange: { startDate, endDate } = {
      startDate: moment().startOf('day'),
      endDate: moment().endOf('day'),
    },
  }: IMachineJobsFilter): Observable<IMachineTotals> =>
    this.http
      .get<IMachineTotals>(
        `${
          this.constants.DATAWORKS_TOTALS_ENDPOINT
        }?machineId=${machineId}&from=${moment(startDate).format(
          'YYYY-MM-DDTHH:mm:ss'
        )}&to=${moment(endDate).format('YYYY-MM-DDTHH:mm:ss')}`
      )
      .pipe(
        retry(this.constants.HTTP_REQUEST_RETRY_TIMES),
        catchError(this.errorHandlingService.handleHttpError)
      );
}
